import script from "./SaveData.vue?vue&type=script&lang=ts&setup=true"
export * from "./SaveData.vue?vue&type=script&lang=ts&setup=true"

import "./SaveData.vue?vue&type=style&index=0&id=5978e1b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5978e1b6"]])

export default __exports__